import React from "react";
import * as Datetime from "react-datetime";
import { FormField } from ".";
import { ValidatedFormFieldBase } from "../validation";
import * as moment from "moment";

interface OwnProps {
    className?: string;
    format?: string;
    inputClassName?: string;
    placeholder?: string;
    viewDate?: Date | string | moment.Moment;
    viewMode?: Datetime.ViewMode | number;
}

interface OwnState {
    dateOpen: boolean;
    timeOpen: boolean;
}

export class TimePickerField extends ValidatedFormFieldBase<OwnProps, OwnState> {

    constructor(props: any) {
        super(props);
        this.state = {
            dateOpen: false,
            timeOpen: false,
        };
    }

    public render() {
        const timeFormat = this.props.format || "h:mm a";
        const label = this.getLabel(this.props.label);
        const value: Date | null | undefined = this.getValue() as Date;

        return <FormField {...this.props} errors={this.getErrors()} label={label} name={this.props.name} required={this.isRequired(this.props.required)}>
            <div className="datetime-field">
                <input type="hidden" name={this.props.name} onChange={() => {}} />

                <Datetime
                    className={this.props.className}
                    closeOnSelect
                    dateFormat={false}
                    onChange={(date) => this.handleTimeChange(date)}
                    inputProps={{
                        className: this.props.inputClassName || "txt-date",
                        placeholder: this.props.placeholder !== undefined ? this.props.placeholder : "hh:mm",
                        value: value && moment(value).startOf("day").valueOf() !== value.valueOf()
                            ? moment(value).format(timeFormat)
                            : "",
                    }}
                    timeFormat={timeFormat}
                    value={value ? moment(value) : undefined}
                    viewDate={this.props.viewDate}
                    viewMode={this.props.viewMode}
                />
            </div>
        </FormField>;
    }

    private handleTimeChange(time: string | moment.Moment) {
        const m = typeof time === "string"
            ? moment(time)
            : time;

        let dateVal = this.props.formComponent.getFieldValue(this.props.name) as Date | undefined | null;
        if (!dateVal)
            dateVal = new Date();

        const dateMoment = moment(dateVal).startOf("day");
        const newDate = m.isValid()
            ? dateMoment
                .add(m.hours(), "hours")
                .add(m.minutes(), "minutes")
                .toDate()
            : dateMoment;

        this.props.formComponent.setFieldValue(this.props.name, newDate);
    }
}



// WEBPACK FOOTER //
// ./src/components/editors/TimePickerField.tsx